import { combineReducers } from 'redux'

import allergensReducer from './allergens-reducer'
import courseTypesReducer from './course-types-reducer'
import cuisineTypesReducer from './cuisine-types-reducer'
import dietsReducer from './diets-reducer'
import dishTypesReducer from './dish-types-reducer'
import eventsReducer from './events-reducer'
import ingredientSupportingKeywordsReducer from './ingredient-keywords-reducer'
import ingredientsReducer from './ingredients-reducer'
import languagesReducer from './languages-reducer'
import usersReducer from './users-reducer'

const commonCombinedReducer = combineReducers({
  cuisineTypes: cuisineTypesReducer,
  dishTypes: dishTypesReducer,
  languages: languagesReducer,
  courseTypes: courseTypesReducer,
  ingredients: ingredientsReducer,
  ingredientKeywords: ingredientSupportingKeywordsReducer,
  diets: dietsReducer,
  allergens: allergensReducer,
  events: eventsReducer,
  users: usersReducer,
})

export default commonCombinedReducer
